import { useMemo } from 'react';
import { CircularLoader, ConfirmationModal } from 'seagull';
import { QueryKeys } from "../hooks/reactQuery/queryKeys";
import { useQueryState } from "../hooks/reactQuery/useQueryState";
import { RichTextViewer } from "../RichTextViewer";
import { jsx as _jsx } from "react/jsx-runtime";
function getDefaultText(text) {
  if (!text) {
    return [];
  }
  return typeof text === 'string' ? [{
    typ: 'p',
    children: [{
      text
    }]
  }] : text;
}
export default function RichTextViewerModal(_ref) {
  let {
    title,
    text,
    fetchText,
    onClose,
    queryKey
  } = _ref;
  const {
    data: richText,
    isLoading
  } = useQueryState({
    queryKey: [QueryKeys.RichText, queryKey],
    queryFn: () => fetchText === null || fetchText === void 0 ? void 0 : fetchText(),
    enabled: !!fetchText
  });
  const loader = useMemo(() => /*#__PURE__*/_jsx("div", {
    style: {
      position: 'absolute',
      top: 'calc(50% - 16px)',
      left: 'calc(50% - 16px)'
    },
    children: /*#__PURE__*/_jsx(CircularLoader, {
      size: 32
    })
  }), []);
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    overflowContent: true,
    contentPadding: "small",
    width: "800px",
    height: "calc(100% - 128px)",
    title: title,
    onCloseButtonClick: onClose,
    content: /*#__PURE__*/_jsx("div", {
      "data-testid": "rich-text-viewer-modal-content",
      style: {
        width: 720,
        margin: '0px 40px 0px 40px',
        textAlign: 'left'
      },
      children: isLoading ? loader : /*#__PURE__*/_jsx(RichTextViewer, {
        value: getDefaultText(richText !== null && richText !== void 0 ? richText : text)
      })
    })
  });
}